import React, { useState } from "react";
import { TableCell, TableRow } from "../../../../design/table";
import { ClientFile } from "@visitproof/types";
import FileActionButtons from "../../../../components/FileActionButtons";
import DeleteCaseFileButton from "./DeleteCaseFileButton";
import { Switch } from "../../../../design/switch";
import { useCase } from "../../../../contexts/CaseContext";

type File = ClientFile;

interface Props {
  file: File;
  caseId: string;
}

const CaseDetailFileListItem: React.FC<Props> = ({ file, caseId }) => {
  const { updateFileInCase } = useCase();
  const [isVisibleToSupervisor, setIsVisibleToSupervisor] = useState(
    file.isVisibleToSupervisor,
  );

  const handleSwitchChange = async () => {
    if (!file.id) {
      console.error("File ID is required");
      return;
    }
    try {
      updateFileInCase(caseId, file.id, {
        isVisibleToSupervisor: !file.isVisibleToSupervisor,
      });
    } catch (error) {
      console.error("Error updating file:", error);
      alert("Failed to update file. Please try again later.");
    }
    setIsVisibleToSupervisor(!isVisibleToSupervisor);
  };

  return (
    <TableRow key={file.id} title={`Visit #${file.id}`}>
      <TableCell>{file.name}</TableCell>
      <TableCell>{file.description}</TableCell>
      <TableCell>
        <Switch checked={isVisibleToSupervisor} onChange={handleSwitchChange} />
      </TableCell>
      <TableCell className="flex items-end justify-end gap-2">
        <FileActionButtons path={file.path} />
        <DeleteCaseFileButton caseId={caseId} file={file} />
      </TableCell>
    </TableRow>
  );
};

export default CaseDetailFileListItem;
